export default "__VITE_PUBLIC_ASSET__7a61831e__"